/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-switch': {
    width: 18,
    height: 22,
    viewBox: '0 0 18 22',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M11.293 1.707l2.294 2.294H5a5 5 0 00-5 5v3h2v-3a3 3 0 013-3h8.585l-2.292 2.292 1.414 1.414L17.414 5 12.707.293l-1.414 1.414zM6.707 20.293L4.414 18H13a5 5 0 005-5v-3h-2v3a3 3 0 01-3 3H4.414l2.293-2.293-1.414-1.414L.586 17l4.707 4.707 1.414-1.414z" _fill="#566473"/>'
  }
})
